import { render, staticRenderFns } from "./news-card.vue?vue&type=template&id=1f91d8cd&scoped=true&"
import script from "./news-card.vue?vue&type=script&lang=js&"
export * from "./news-card.vue?vue&type=script&lang=js&"
import style0 from "./news-card.vue?vue&type=style&index=0&id=1f91d8cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f91d8cd",
  null
  
)

export default component.exports